<template>
  <q-dialog
    ref="dialog"
    :maximized="$q.platform.is.mobile"
    @hide="onDialogHide"
  >
    <q-card class="map-wrap">
      <q-card-section class="row">
        <div class="text-h6 ellipsis col">
          {{ title }}
        </div>
        <q-btn
          v-close-popup
          flat
          round
          dense
          icon="close"
        />
      </q-card-section>
      <q-card-section :class="{'q-pa-none': $q.screen.lt.md}">
        <GoogleMap
          :api-key="gmapKey"
          class="map-size"
          :center="coords"
          :zoom="zoom"
        >
          <GoogleMapMarker :options="{ position: coords, clickable: false }" />
        </GoogleMap>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>
<script>
import { GoogleMap, Marker } from 'vue3-google-map';

export default {
  name: 'SessionGoogleMapsPoints',

  components: {
    GoogleMap,
    GoogleMapMarker: Marker,
  },

  props: {
    coords: {
      type: Object,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },
  },

  emits: ['hide'],

  data() {
    return {
      zoom: 11,
    };
  },

  computed: {
    gmapKey() {
      return process.env.ENV_TYPE === 'production'
        ? 'AIzaSyDereHA5jM9tPulMqYeyq08m9rwpgsIEpo'
        : 'AIzaSyDq_rVjDCreAaTO4HT9ufHB5q0G-Tc6xDU';
    },
  },

  methods: {
    show() {
      this.$refs.dialog.show();
    }, // show()

    hide() {
      this.$emit('hide');

      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    }, // hide()

    onDialogHide() {
      this.$emit('hide');
    }, // onDialogHide()
  },
};
</script>

<style lang="scss" scoped>

.map-wrap {
  width: 700px;
}
.map-size {
  height: 450px;
  width: 100%;
}
@media only screen and (min-width: $breakpoint-sm-max) {
  .map-wrap {
    max-width: 75vw;
  }
}
@media only screen and (max-width: $breakpoint-sm-max) {
  .map-size {
    height: 85vh;
  }
}
</style>
